import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronLeftDouble = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2928 7.29297L13.2928 11.293C12.9023 11.6835 12.9023 12.3167 13.2928 12.7072L17.2928 16.7072L18.707 15.293L15.4141 12.0001L18.707 8.70718L17.2928 7.29297ZM10.2928 7.29297L6.29282 11.293C5.90229 11.6835 5.90229 12.3167 6.29282 12.7072L10.2928 16.7072L11.707 15.293L8.41414 12.0001L11.707 8.70718L10.2928 7.29297Z"
        />
      </svg>
    );
  }
);
